import Vue from "vue"

import App from "./App.vue"

import routers from "./routes"
import store from "./store"

import utils from "./utils";

import ve from "./mixins/vue-esc";
Vue.use( ve );

import vd from "./mixins/vue-debounce";
Vue.use( vd );

import vdg from "./mixins/vue-draggable";
Vue.use( vdg );

import vok from "./mixins/vue-ok";
Vue.use( vok );

import vr from "./mixins/vue-resizable";
Vue.use( vr );

import vc from "./mixins/vue-closable";
Vue.use( vc );

import vs from "./mixins/vue-clicks";
Vue.use( vs );

import VueApexCharts from "vue-apexcharts";
Vue.use( VueApexCharts );
Vue.component( "Apexchart", VueApexCharts );

import VueI18n from "vue-i18n";
Vue.use( VueI18n );
const i18n = new VueI18n(
  {
    locale:         store.state.global.langInterf,
    fallbackLocale: "ru",
    
    messages: {
      ru: {
        ru:                       "русский",
        Ru:                       "@.capitalize:ru",
        en:                       "английский",
        En:                       "@.capitalize:en",
        kz:                       "казахский",
        Kz:                       "@.capitalize:kz",
        ru2:                      "ру",
        en2:                      "ан",
        kz2:                      "кз",
        ok:                       "ок",
        Ok:                       "@.capitalize:ok",
        cancel:                   "отмена",
        Cancel:                   "@.capitalize:cancel",
        close:                    "закрыть",
        Close:                    "@.capitalize:close",
        yes:                      "да",
        Yes:                      "@.capitalize:yes",
        no:                       "нет",
        No:                       "@.capitalize:no",
        apply:                    "применить",
        Apply:                    "@.capitalize:apply",
        import:                   "импортировать",
        Import:                   "@.capitalize:import",
        URI:                      "URI",
        ChangesSave:              "Сохранить изменения",
        ChangesCancel:            "Отменить изменения",
        MarkUnmarkAll:            "Пометить/снять пометку со всех строк",
        ObjectView:               "Просмотр объекта",
        date:                     "дата",
        Date:                     "@.capitalize:date",
        user:                     "пользователь",
        User:                     "@.capitalize:date",
        Class:                    "Класс",
        Properties:               "Свойства",
        Create:                   "Создание",
        Update:                   "Изменение",
        Delete:                   "Удалить",
        Endpoint:                 "Точка",
        Refresh:                  "Обновить",
        ExportXLS:                "Экспорт в Excel",
        ImportXLS:                "Импорт из Excel",
        DataNotFound:             "Данных не найдено...",
        Error:                    "Ошибка",
        Property:                 "Свойство",
        value:                    "значение",
        Value:                    "@.capitalize:value",
        DataRequestError:         "Ошибка получения данных",
        FileRequestError:         "Ошибка получения файла",
        InvalidServerAnswer:      "Неверный ответ сервера",
        String:                   "Строка",
        file:                     "файл",
        File:                     "@.capitalize:file",
        NothingSave:              "Нечего сохранять",
        ObjectsSaveError:         "Ошибка сохранения объекта(в)",
        ObjectsDeleteError:       "Ошибка удаления объекта(в)",
        ViolationsDetected:       "Обнаружено нарушение(я)",
        ViolationConstraintsRules:"Нарушение правил контроля логической целостности",
        object:                   "объект",
        Object:                   "@.capitalize:object",
        savedSuc:                 "успешно сохранен",
        deletedSuc:               "успешно удален",
        MarkAtleastOne:           "пометьте хотя-бы один объект",
        DeleteError:              "Ошибка удаления",
        DeleteObjects:            "Вы действительно хотите удалить этот объект(ы)?",
        Classes:                  "Классы",
        creating:                 "создание",
        updating:                 "изменение",
        deleting:                 "удаление",
        attribute:                "атрибут",
        attributes:               "атрибуты",
        Creating:                 "@.capitalize:creating",
        Updating:                 "@.capitalize:updating",
        Deleting:                 "@.capitalize:deleting",
        Attribute:                "@.capitalize:attribute",
        Attributes:               "@.capitalize:attributes",
        language:                 "язык",
        type:                     "тип",
        Type:                     "@.capitalize:type",
        values:                   "значения",
        notFound:                 "не найден",
        attrCantBeDisplayed:      "атрибут \"{id}\" не может быть отображен",
        sorting:                  "сортировка",
        Sorting:                  "@.capitalize:sorting",
        ascending:                "по возрастанию",
        descending:               "по убыванию",
        operation:                "операция",
        Operation:                "@.capitalize:operation",
        filtering:                "фильтрация",
        Filtering:                "@.capitalize:filtering",
        column:                   "столбец",
        Column:                   "@.capitalize:column",
        ObjectsChangedByRules:    "Правилами логического вывода изменены объекты",
        Scheduler:                "Планировщик заданий",
        Description:              "Описание"
      },
      
      en: {
        ru:                       "russian",
        Ru:                       "@.capitalize:ru",
        en:                       "english",
        En:                       "@.capitalize:en",
        kz:                       "kazakh",
        Kz:                       "@.capitalize:kz",
        ru2:                      "ru",
        en2:                      "en",
        kz2:                      "kz",
        ok:                       "ok",
        Ok:                       "@.capitalize:ok",
        cancel:                   "cancel",
        Cancel:                   "@.capitalize:cancel",
        close:                    "close",
        Close:                    "@.capitalize:close",
        yes:                      "yes",
        Yes:                      "@.capitalize:yes",
        no:                       "no",
        No:                       "@.capitalize:no",
        apply:                    "apply",
        Apply:                    "@.capitalize:apply",
        import:                   "import",
        Import:                   "@.capitalize:import",
        URI:                      "URI",
        ChangesSave:              "Save changes",
        ChangesCancel:            "Cancel changes",
        MarkUnmarkAll:            "Mark/unmark all rows",
        ObjectView:               "View object",
        date:                     "date",
        Date:                     "@.capitalize:date",
        user:                     "user",
        User:                     "@.capitalize:date",
        Class:                    "Class",
        Properties:               "Properties",
        Create:                   "Create",
        Update:                   "Update",
        Delete:                   "Delete",
        Endpoint:                 "Endpoint",
        Refresh:                  "Refresh",
        ExportXLS:                "Export to Excel",
        ImportXLS:                "Import from Excel",
        DataNotFound:             "No data found...",
        Error:                    "Error",
        Property:                 "Property",
        value:                    "value",
        Value:                    "@.capitalize:value",
        DataRequestError:         "Data request error",
        FileRequestError:         "File request error",
        InvalidServerAnswer:      "Invalid server answer",
        String:                   "String",
        file:                     "file",
        File:                     "@.capitalize:file",
        NothingSave:              "Nothing to save",
        ObjectsSaveError:         "Object(s) save error",
        ObjectsDeleteError:       "Object(s) delete error",
        ViolationsDetected:       "Violation(s) detected",
        ViolationConstraintsRules:"Violation of constraints rules",
        object:                   "object",
        Object:                   "@.capitalize:object",
        savedSuc:                 "saved successfully",
        deletedSuc:               "deleted successfully",
        MarkAtleastOne:           "Please mark at least one object",
        DeleteError:              "Delete error",
        DeleteObjects:            "Are you sure you want to delete this object(s)?",
        Classes:                  "Classes",
        creating:                 "creating",
        updating:                 "updating",
        deleting:                 "deleting",
        attribute:                "attribute",
        attributes:               "attributes",
        Creating:                 "@.capitalize:creating",
        Updating:                 "@.capitalize:updating",
        Deleting:                 "@.capitalize:deleting",
        Attribute:                "@.capitalize:attribute",
        Attributes:               "@.capitalize:attributes",
        language:                 "language",
        type:                     "type",
        Type:                     "@.capitalize:type",
        values:                   "values",
        notFound:                 "is not found",
        attrCantBeDisplayed:      "attributeт \"{id}\" can't be displayed",
        sorting:                  "Sorting",
        Sorting:                  "@.capitalize:sorting",
        ascending:                "by ascending",
        descending:               "by descending",
        operation:                "operation",
        Operation:                "@.capitalize:operation",
        filtering:                "filtering",
        Filtering:                "@.capitalize:filtering",
        column:                   "column",
        Column:                   "@.capitalize:column",
        ObjectsChangedByRules:    "Objects changed by inference rules",
        Scheduler:                "Task scheduler",
        Description:              "Description"
      },
      
      kz: {
        ru:                       "орыс",
        Ru:                       "@.capitalize:ru",
        en:                       "ағылшын",
        En:                       "@.capitalize:en",
        kz:                       "қазақ",
        Kz:                       "@.capitalize:kz",
        ru2:                      "ор",
        en2:                      "ағ",
        kz2:                      "кз",
        ok:                       "қз",
        Ok:                       "@.capitalize:ok",
        cancel:                   "жою",
        Cancel:                   "@.capitalize:cancel",
        close:                    "жабық",
        Close:                    "@.capitalize:close",
        yes:                      "иә",
        Yes:                      "@.capitalize:yes",
        no:                       "Жоқ",
        No:                       "@.capitalize:no",
        apply:                    "қолдану",
        Apply:                    "@.capitalize:apply",
        import:                   "импорттау",
        Import:                   "@.capitalize:import",
        URI:                      "URI",
        ChangesSave:              "Өзгерістерді сақтау",
        ChangesCancel:            "Өзгерістерден бас тарту",
        MarkUnmarkAll:            "Барлық жолдарды белгілеу/белгіні алу",
        ObjectView:               "Объектіні қарау",
        date:                     "күні",
        Date:                     "@.capitalize:date",
        user:                     "пайдаланушы",
        User:                     "@.capitalize:date",
        Class:                    "Сынып",
        Properties:               "Сипаттар",
        Create:                   "Жасау",
        Update:                   "Жаңарту",
        Delete:                   "Жою",
        Endpoint:                 "Кіру нүктесі",
        Refresh:                  "Жаңарту",
        ExportXLS:                "Excel экспорттау",
        ImportXLS:                "Excel импорттау",
        DataNotFound:             "Деректер табылмады...",
        Error:                    "Қате",
        Property:                 "Қасиеті",
        value:                    "мағынасы",
        Value:                    "@.capitalize:value",
        DataRequestError:         "Деректерді алу қатесі",
        FileRequestError:         "Файлды алу қатесі",
        InvalidServerAnswer:      "Жарамсыз сервер жауабы",
        String:                   "Түзу",
        file:                     "файл",
        File:                     "@.capitalize:file",
        NothingSave:              "Сақтайтын ештеңе жоқ",
        ObjectsSaveError:         "Нысан(дарды) сақтау қатесі",
        ObjectsDeleteError:       "Нысан(дарды) жою қатесі",
        ViolationsDetected:       "бұзушылық(тар) анықталды",
        ViolationConstraintsRules:"Логикалық тұтастықты бақылау ережелерін бұзу",
        object:                   "нысан",
        Object:                   "@.capitalize:object",
        savedSuc:                 "сәтті сақталды",
        deletedSuc:               "сәтті жойылды",
        MarkAtleastOne:           "кем дегенде бір нысанды белгілеңіз",
        DeleteError:              "Жою қатесі",
        DeleteObjects:            "Бұл нысан(дарды) шынымен жойғыңыз келе ме?",
        Classes:                  "Сыныптар",
        creating:                 "жасау",
        updating:                 "өзгерту",
        deleting:                 "жою",
        attribute:                "атрибут",
        attributes:               "атрибуттар",
        Creating:                 "@.capitalize:creating",
        Updating:                 "@.capitalize:updating",
        Deleting:                 "@.capitalize:deleting",
        Attribute:                "@.capitalize:attribute",
        Attributes:               "@.capitalize:attributes",
        language:                 "тіл",
        type:                     "түрі",
        Type:                     "@.capitalize:type",
        values:                   "мәндер",
        notFound:                 "табылмады",
        attrCantBeDisplayed:      "атрибут \"{id}\" не может быть отображен",
        sorting:                  "сұрыптау",
        Sorting:                  "@.capitalize:sorting",
        ascending:                "өсу",
        descending:               "Кему кезінде",
        operation:                "операция",
        Operation:                "@.capitalize:operation",
        filtering:                "сүзу",
        Filtering:                "@.capitalize:filtering",
        column:                   "баған",
        Column:                   "@.capitalize:column",
        ObjectsChangedByRules:    "Қорытынды ережелерімен өзгертілген нысандар",
        Scheduler:                "Тапсырманы жоспарлаушы",
        Description:              "Сипаттама"
      }
    },
    
    globalInjection: true,
    silentTranslationWarn: true
  },
);

import config from "./config";
import api from "./api";
import dates from "./dates"

const languages = [ 'ru', 'en', 'kz' ];

Vue.prototype.$langBrief = function( id ) {
  if ( this && this.$t && id ) return this.$t( ( "" + id ).toLowerCase() + "2" );
  return "";
};

const attrsPrefixesCantView = [
  "http://www.w3.org/"
];
Vue.prototype.$checkAttrCanView = function( id ) {
  for ( const p of attrsPrefixesCantView ) {
    if ( id.indexOf( p ) === 0 ) return false;
  }

  return true;
};

Vue.prototype.$attrCanView = function( id ) {
};

Vue.mixin(
  {
    limit:         config.limit,
    chunkSize:     config.chunkSize,
    server:        config.server,
    client:        config.client,
    api,
    languages,

    severities: [
      "http://www.w3.org/ns/shacl#Violation",
      "http://www.w3.org/ns/shacl#Warning",
      "http://www.w3.org/ns/shacl#Info"
    ],

    //standard attributes which are included in classes tree
    attrsStdInclude: [
      "http://www.w3.org/ns/shacl#",
      "http://www.w3.org/ns/prov#",
      "http://www.w3.org/2002/07/owl#Class",
      "http://www.w3.org/2002/07/owl#DatatypeProperty",
      "http://www.w3.org/2002/07/owl#ObjectProperty",
      "http://www.w3.org/2004/02/skos/core#Concept"
    ],

    methods: {
		  permitted( right, endpoint, misc ) {
		    if (
		      this.$store &&
          this.$store.state.user &&
          this.$store.state.user.isLoggedIn &&
		      this.$store.state.user.rights
        ) {
		      if ( this.$store.state.user.rights.use ) {
  		      const rights = this.$store.state.user.rights;

		        if (
     		      rights.available &&
              rights.permissions
            ) {
              if ( rights.available.common.includes( right ) ) {
                if ( !( "common" in rights.permissions ) || utils.objIsEmpty( rights.permissions.common ) ) return true; //!!!

                return right in rights.permissions.common ? !!rights.permissions.common[ right ] : false;
              }

              if ( !( "byEndpoints" in rights.permissions ) || utils.objIsEmpty( rights.permissions.byEndpoints ) ) return true; //!!!

              if (
                endpoint &&
                rights.permissions.byEndpoints &&
                ( endpoint in rights.permissions.byEndpoints ) &&
                rights.permissions.byEndpoints[ endpoint ]
              ) {
                const userRightValue = rights.permissions.byEndpoints[ endpoint ][ right ];

                if ( right === "XLSexport" && Array.isArray( userRightValue ) ) {
                  if ( misc ) {
                    if ( !Array.isArray( misc ) ) misc = [ misc ];
                    return misc.every( cid => userRightValue.includes( cid ) );
                  }

                  return false;
                }

                return !!userRightValue;
              }
            }
          }
		      else return true;
        }

		    return false;
      }
    },

    computed: {
      clientId() {
        return store.state.user.clientId;
      },
      langInterf: {
        get() {
          return store.state.global.langInterf;
        },
        set( v ) {
          if ( store.state.global.langInterf !== v ) {
            store.commit( "global/setLangInterf", v );
            this.$root.$emit( "render" );
          }
        }
      },
      langData: {
        get() {
          return store.state.global.langData;
        },
        set( v ) {
          if ( store.state.global.langData !== v ) {
            store.commit( "global/setLangData", v );
            this.$root.$emit( "render" );
          }
        }
      },
      dateData: {
        get() {
          return store.state.global.dateData;
        },
        set( v ) {
          if ( store.state.global.dateData !== v ) {
            store.commit( "global/setDateData", v );
            this.$root.$emit( "render" );
          }
        }
      },
      limit: {
        get() {
          return store.state.global.limit;
        },
        set( v ) {
          if ( store.state.global.limit !== v ) {
            store.commit( "global/setLimit", v );
          }
        }
      },
      chunkSize: {
        get() {
          return store.state.global.chunkSize;
        },
        set( v ) {
          if ( store.state.global.chunkSize !== v ) {
            store.commit( "global/setChunkSize", v );
          }
        }
      },
      queryStd() {
        return {
          ...this.langData && { lang: this.langData },
          ...this.dateData && { date: dates.format( this.dateData, dates.types.RUS4Y, dates.types.ISO, true, true  ) },
          ...this.limit && { itemsPerPage: this.limit }
        }
      },
      dateType() {
        return this.$i18n.locale === "en" ? dates.types.ENG : dates.types.RUS4Y;
      }
    }
  }
);

store.subscribe(
  ( mutation, state ) => {
    if ( mutation && mutation.type == "global/setLangInterf" ) {
      i18n.locale = state.global.langInterf;
    }
  }
);

window.app = new Vue(
  {
    router: routers,
    store,
    i18n,
    render: h => h( App ),
    provide: {
    },
  	data: {
    	pageTitle: ""
	  }
  }
).$mount( "#app" );
